function toAmount (value) {
  const amount = Number(value)
  return Number.isFinite(amount) ? amount : 0
}

function normalizeSourceIds (value) {
  if (Array.isArray(value)) {
    return value.reduce((ids, item) => ids.concat(normalizeSourceIds(item)), [])
  }

  if (value && typeof value === 'object') {
    return normalizeSourceIds(value.vaOid || value.id || value.oid)
  }

  const source = String(value || '').trim()
  if (!source) return []

  if (source.startsWith('[')) {
    try {
      return normalizeSourceIds(JSON.parse(source))
    } catch {
      // 不是 JSON 时继续按普通分隔字符串处理
    }
  }

  return source.split(/[,;|\s]+/).filter(Boolean)
}

function getPaymentSourceIds (order) {
  return new Set([
    ...normalizeSourceIds(order?.id),
    ...normalizeSourceIds(order?.jyorders),
  ])
}

function isFrozenRowApplicable (row, order, paymentSourceIds) {
  const unfreezeSourceIds = normalizeSourceIds(row?.unfrzSources)
  if (unfreezeSourceIds.length) {
    return unfreezeSourceIds.some(sourceId => paymentSourceIds.has(sourceId))
  }

  const jyOid = String(order?.jyOid || '').trim()
  return !!jyOid && String(row?.frzSource || '').trim() === jyOid
}

/**
 * 计算本次付款可以使用的冻结金额。
 * 新响应以 unfrzSources 精确关联付款单；旧响应回退到冻结来源订单。
 */
export function getApplicableFrozenAmount (rows, order, totalFrozenAmount) {
  if (!Array.isArray(rows) || !rows.length || !order) return 0

  const paymentSourceIds = getPaymentSourceIds(order)
  const applicableAmount = rows.reduce((amount, row) => {
    if (!isFrozenRowApplicable(row, order, paymentSourceIds)) return amount
    const remainingAmount = Math.max(0, toAmount(row.frzAmount) - toAmount(row.lgAmount))
    return amount + remainingAmount
  }, 0)

  if (totalFrozenAmount === undefined || totalFrozenAmount === null || totalFrozenAmount === '') {
    return applicableAmount
  }
  return Math.min(applicableAmount, Math.max(0, toAmount(totalFrozenAmount)))
}
